var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3250_717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.333 45C172.917 45 139.333 78.5833 139.333 120H114.333L146.75 152.417L147.333 153.583L181 120H156C156 87.75 182.083 61.6667 214.333 61.6667C246.583 61.6667 272.667 87.75 272.667 120C272.667 152.25 246.583 178.333 214.333 178.333C198.25 178.333 183.667 171.75 173.167 161.167L161.333 173C174.917 186.583 193.583 195 214.333 195C255.75 195 289.333 161.417 289.333 120C289.333 78.5833 255.75 45 214.333 45ZM206 86.6667V128.333L241.667 149.5L247.667 139.417L218.5 122.083V86.6667H206Z",
    fill: "var(--card-thumbnail-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3250_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(106 20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryTable);
export default __webpack_public_path__ + "static/media/history-table.0b66807500b79d2bd15b71a872576f6c.svg";
export { ForwardRef as ReactComponent };